import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "maxLines", "overrideCss"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { useContext } from 'react';
import { FlexibleUiContext } from '../../../../../state/flexible-ui-context';
import Text from '../text';
var SNIPPET_DEFAULT_MAX_LINES = 3;
var getSnippetStyles = function getSnippetStyles(overrideCss) {
  return css({
    color: "var(--ds-text, #172B4D)",
    WebkitUserSelect: 'text',
    MozUserSelect: 'text',
    MsUserSelect: 'text',
    userSelect: 'text'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  overrideCss);
};
var SnippetElement = function SnippetElement() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var overrideContent = _ref.content,
    _ref$maxLines = _ref.maxLines,
    maxLines = _ref$maxLines === void 0 ? SNIPPET_DEFAULT_MAX_LINES : _ref$maxLines,
    overrideCss = _ref.overrideCss,
    props = _objectWithoutProperties(_ref, _excluded);
  var context = useContext(FlexibleUiContext);
  return jsx(Text, _extends({
    content: overrideContent !== null && overrideContent !== void 0 ? overrideContent : context === null || context === void 0 ? void 0 : context.snippet,
    maxLines: maxLines,
    overrideCss: getSnippetStyles(overrideCss)
  }, props));
};
export default SnippetElement;